module.exports = __webpack_public_path__ + "img/51.46a513c.jpg";